
import { defineComponent } from "vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";
import { Routes } from "@/router";

export default defineComponent({
  components: {
    BaseTypography,
  },
  setup() {
    return {
      buttonTitle: "Forgot password?",
      forgotPasswordRouteLocation: { name: Routes.forgotPassword },
    };
  },
});
